import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "./ui/card";

type NotFoundProps = {
  title: string;
  description: string;
  footer?: React.ReactNode;
};

export default function NotFound({
  title,
  description,
  footer,
}: NotFoundProps) {
  return (
    <div className="container max-w-6xl mx-auto py-12 px-4">
      <Card className="shadow-lg border-t-4 border-red-500">
        <CardHeader>
          <CardTitle className="text-2xl font-bold text-red-600">
            {title}
          </CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        {footer && <CardFooter>{footer}</CardFooter>}
      </Card>
    </div>
  );
}
